<template>
  <el-dialog
    :visible.sync="showDialog"
    :before-close="handleClose"
    :width="modalWidth"
    top="20vh"
    :showClose="false"
  >
    <div class="flex flex-col gap-3 mt-4">
      <h3 class="text-base text-black-10 text-center">Attention</h3>
      <p class="font-normal text-center text-xs sm:text-sm">
        Are you sure you want to cancel this {{ reasonType || 'Withdrawal' }}?
      </p>

      <div class="mx-4">
        <el-form
          label-position="top"
          :model="form"
          ref="form"
          :rules="rules"
          @submit.native.prevent="validateForm('form')"
          @keyup.enter.native="validateForm('form')"
        >
          <el-form-item label="Reason" prop="reason" class="mb-4">
            <el-input v-model="form.reason"></el-input>
          </el-form-item>

          <div class="mt-6 sm:mt-8 flex justify-center gap-4">
            <button
              class="bg-gray-200 text-black-10 py-3 px-10 sm:px-14"
              type="submit"
            >
              Yes
            </button>
            <button
              @click="handleClose"
              class="bg-primary text-white py-3 px-10 sm:px-14"
              type="button"
            >
              No
            </button>
          </div>
        </el-form>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { ValidateInput } from '@/utils/helpers'
import breakpoints from '@/utils/breakpoints.js'

export default {
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    reasonType: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      breakpoints,
      rules: {
        reason: [
          {
            required: true,
            message: 'Reason is required',
            trigger: ['blur', 'change']
          },
          { validator: ValidateInput, trigger: ['blur', 'change'] }
        ]
      },
      form: {
        reason: ''
      }
    }
  },
  computed: {
    modalWidth () {
      return breakpoints.lgAndUp ? '30%' : breakpoints.mdAndUp ? '60%' : '90%'
    }
  },
  methods: {
    handleClose () {
      this.$emit('closeDialog')
    },
    validateForm (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          this.$emit('handleCancelreason', this.form.reason)
        } else {
          this.$notify.error({
            title: 'Invalid Input',
            message: 'Please enter a valid reason',
            position: 'top-right'
          })
        }
      })
    }
  }
}
</script>

<style scoped>
button {
  border-radius: 8px;
  font-size: 14px;

  &:active {
    transform: translateY(1px);
  }
}

>>> .el-dialog {
  border-radius: 20px;
  padding: 0px 20px 10px 10px;
}
>>> .el-dialog__body {
  padding: 0px 10px;
}
>>> .el-input {
  border: 1px solid #bfc0cb;
  border-radius: 8px;
  width: 100%;

  &:hover,
  &:focus {
    border: 1px solid #8b8c94;
  }
}
>>> .el-input__inner {
  padding-right: 3px;
  color: #171717;
  border-radius: 8px;
  height: 48px;
}
</style>
